import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaUserShield } from 'react-icons/fa';
import api from '../utils/api';
import './InitialSetup.css';

const InitialSetup = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    confirmPassword: '',
    phone: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    // Handle phone number with +91 prefix
    if (name === 'phone') {
      let phoneValue = value.replace(/[^0-9+]/g, ''); // Allow only numbers and +
      
      // If user starts typing and doesn't include +91, add it
      if (phoneValue && !phoneValue.startsWith('+91')) {
        // Remove any existing + at the start
        phoneValue = phoneValue.replace(/^\+/, '');
        phoneValue = '+91' + phoneValue;
      }
      
      // Limit to +91 + 10 digits (13 characters total)
      if (phoneValue.length > 13) {
        phoneValue = phoneValue.substring(0, 13);
      }
      
      setFormData({
        ...formData,
        phone: phoneValue
      });
      return;
    }
    
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    // Validation
    if (formData.password !== formData.confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    if (formData.password.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }

    setLoading(true);

    try {
      const { confirmPassword, ...userData } = formData;
      const response = await api.post('/users/initial-admin', userData);
      
      // Store token and user data
      localStorage.setItem('userInfo', JSON.stringify(response.data));
      
      // Redirect to admin dashboard
      navigate('/admin');
    } catch (error) {
      console.error('Error creating initial admin:', error);
      setError(error.response?.data?.message || 'Failed to create admin user');
      setLoading(false);
    }
  };

  return (
    <div className="initial-setup">
      <div className="setup-container">
        <div className="setup-header">
          <div className="setup-icon">
            <FaUserShield />
          </div>
          <h1>Initial Setup</h1>
          <p>Create your first admin account to get started</p>
        </div>

        {error && (
          <div className="error-message">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="setup-form">
          <div className="form-group">
            <label htmlFor="name">Full Name *</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder="Enter your full name"
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email Address *</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="admin@example.com"
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="phone">Phone Number</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="+91XXXXXXXXXX"
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password *</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              minLength="6"
              placeholder="Minimum 6 characters"
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="confirmPassword">Confirm Password *</label>
            <input
              type="password"
              id="confirmPassword"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              required
              minLength="6"
              placeholder="Re-enter your password"
              disabled={loading}
            />
          </div>

          <button type="submit" disabled={loading} className="btn btn-primary btn-large">
            {loading ? 'Creating Admin...' : 'Create Admin Account'}
          </button>
        </form>

        <div className="setup-footer">
          <p>This page is only accessible when no admin users exist in the system.</p>
        </div>
      </div>
    </div>
  );
};

export default InitialSetup;
